/* eslint-disable import/no-cycle */
import React from 'react';

import TextMessage from '../text-message/TextMessage';
import FilePreview from './FilePreview.jsx';
import * as fileTypes from '../../constants/fileTypes';
import DownloadButton from '../../../../../components/chat-tools-fool-componets/DownloadButton.jsx';
import { getNameFromServerText, getFileURL, addAttributeToUrls } from './utils.js';
import { ErrorIcon } from '../../../../../components/icons/index.js'

import './FileMessage.scss';

const PREFIX_FOR_OPENING_FILE = '?open=true';
class FileMessage extends TextMessage {
  parse(serverUrl) {
    this.fileUrl = getFileURL(this.text);
    this.filePreviewType = this.getFilePreviewType(this.fileUrl);
    super.parse(serverUrl);
    this.name = getNameFromServerText(this.text);
    this.openUrl = `${this.fileUrl}${PREFIX_FOR_OPENING_FILE}`;
    this.renderText = this.renderText.bind(this);
    this.isBlockedByServer = this.text.indexOf('msg-file-transfer-blocked-url') !== -1;
  }

  getFilePreviewType(url) {
    if (url.match(/file-transfer\/download/gi)) {
      if (url.match(/\.png|\.jpg|\.jpeg|\.svg|\.gif|\.tiff/gi)) {
        return fileTypes.IMAGE;
      }
      if (url.match(/\.mp3|\.wav|\.wav|\.aiff|\.ape|\.flac|\.ogg/gi)) {
        return fileTypes.AUDIO;
      }
      if (url.match(/\.mp4|\.mov|\.avi|\.mkv|\.wmv|\.ogv|\.webm/gi)) {
        return fileTypes.VIDEO;
      }
    }

    return '';
  }

  renderText() {
    const isError = this.isBlockedByServer;
    const text = this.filePreviewType !== fileTypes.AUDIO && this.filePreviewType !== fileTypes.VIDEO
      ? (
        <span
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: addAttributeToUrls(this.text, PREFIX_FOR_OPENING_FILE) }}
        />
      )
      : (
        <a
          href={this.openUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {this.name}
        </a>
      );

    return (
      <div
        className={`message-text-wrapper ${this.filePreviewType || ''}`}
      >
        <div className="file-message-wraper">
          <div className={`file-message ${isError ? 'file-error' : ''}`}>
            <span className="file-name">
              {isError && <ErrorIcon />}
              {text}
            </span>

            {this.filePreviewType
              && (
              <FilePreview
                type={this.filePreviewType}
                url={this.openUrl}
                text={this.text}
              />
              )}

          </div>

          {!isError && <DownloadButton src={this.fileUrl} />}
        </div>
      </div>
    );
  }
}

export default FileMessage;
